import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

export type LastEvalKeyReportsRecord = {
	'userName': string,
	'reportId': string,
	'updatedAt': string | undefined,
	'organisationId': string,
};

export type LastEvaluatedKeyType = Record<string, LastEvalKeyReportsRecord>;

const initialStateLastEvaluatedKey: LastEvaluatedKeyType = {
	reports : {
		'userName': '',
		'reportId': '',
		'updatedAt': undefined,
		'organisationId': 'techpearl'
	}
};

const lastEvaluatedKeyReducer = createSlice({
	name: 'lastEvaluatedKey',
	initialState: initialStateLastEvaluatedKey,
	reducers: {

		setLastEvaluatedKey(state, action) {

			const keyType: string = action.payload.keyType;
			const keyData = action.payload.keyData;

			return {
				...state,
				[keyType]: keyData
			};
		}
	},
	extraReducers(builder) {
		builder
			.addCase(revertAll, () => initialStateLastEvaluatedKey);
	}
});

export const { setLastEvaluatedKey } = lastEvaluatedKeyReducer.actions;

export default lastEvaluatedKeyReducer;
